import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_IDIN: MijnRoute = {
    path: 'idin',
    navigationEvent: 'toIdin',
    regex: /^\/zelf-regelen\/idin$/,
    webcomponent: 'mijn-idin-zelfservice-webcomponent'
};
